import { Chunk } from "./indexedDb";

interface RangeResponse {
  chunks: Chunk[];
  url: string;
  chunkCount: number;
  eTag: string;
  chunkSize: number;
  status: number;
}

export class FetchRange {
  static async fetch(
    url: string,
    etag: string,
    chunkSize = 4194304
  ): Promise<RangeResponse> {
    let offset = 0;
    const headers = new Headers();
    if (etag) {
      headers.append("If-None-Match", etag);
    }
    const preflightRes = await fetch(url, {
      method: "HEAD",
      headers
    });
    const resEtag = preflightRes.headers.get("Etag");
    if (preflightRes.status === 304) {
      return {
        chunkCount: 0,
        chunks: [],
        chunkSize: 0,
        eTag: resEtag || "",
        url,
        status: preflightRes.status
      };
    }
    const chunks: Chunk[] = [];

    const contentLength = parseInt(
      preflightRes.headers.get("Content-Length") || "",
      10
    );
    if (contentLength < 1) {
      throw new Error(`Content-length is empty for ${url}`);
    }

    const chunkCount = Math.trunc(contentLength / chunkSize) + 1;
    for (let i = 1; i <= chunkCount; i++) {
      const from = offset;
      const to = offset + chunkSize;
      // console.log(`before downloading bytes=${from}-${to}`);

      const res = await fetch(url, {
        headers: new Headers({
          Range: `bytes=${from}-${to}`
        })
      });
      const b = await res.blob();
      chunks.push({ blob: b, order: i, to, from });

      offset += chunkSize + 1;
      // console.log(`after downloading bytes=${from}-${to}`);
    }

    return {
      chunks,
      url,
      chunkCount,
      chunkSize,
      eTag: resEtag || "",
      status: preflightRes.status
    };
  }
}
